import React from "react";
import MCCLogo from "../../assets/images/mcc-logo.png";
import { Box } from "@mui/material";

const MccLogo = ({ variant = "login", size }) => {
  const isDialog = variant === "dialog";
  const logoSize = size || (isDialog ? 64 : 98);

  return (
    <Box
      boxShadow="0px 2px 16px 0px rgba(0, 0, 0, 0.08)"
      width={logoSize}
      height={logoSize}
      borderRadius="50%"
      padding={isDialog ? "8px" : "12px"}
      position={isDialog ? "relative" : "absolute"}
      bgcolor="#fff"
      top={isDialog ? "auto" : "0"}
      left={isDialog ? "auto" : "50%"}
      zIndex="99"
      mx={isDialog ? "auto" : 0}
      mb={0}
      flexShrink={0}
      sx={{
        transform: isDialog ? "none" : "translate(-50%, -50%)",
      }}
    >
      <img src={MCCLogo} alt="biosync-logo" width="100%" height="100%" />
    </Box>
  );
};

export default MccLogo;
